// This file is generated, do not modify manually.
// Run `$ yarn i18next` to update this file

export const NAMESPACES = ['account', 'common', 'country', 'demo', 'epg', 'error', 'menu', 'search', 'us_state', 'user', 'video'];
